<template>
  <div>
    <div
      class="-asset-menu-icon"
      v-if="shouldShowMenu"
      @click="toggleMenuActive"
      :class="{ '-active': active }"
    >
      <i class="wticon wticon-hamburger3"></i>
    </div>
    <ul class="-asset-menu" v-if="active" v-click-outside="toggleMenuActive">
      <li v-if="canEdit" @click="emitAction('edit')">
        <i class="wticon wticon-pencil3"></i>
        Edit Info
      </li>
      <li v-if="canDelete" @click="emitAction('delete')">
        <i class="wticon wticon-trash2"></i>
        Delete
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      active: false,
    };
  },

  watch: {
    active(isActive) {
      this.$emit('active', isActive);
    },
  },

  methods: {
    toggleMenuActive(e) {
      if (!e) {
        return;
      }
      if (
        e.currentTarget.classList &&
        e.currentTarget.classList.contains('-asset-menu-icon')
      ) {
        this.active = !this.active;
        e.stopPropagation();
      } else {
        this.active = false;
      }
    },
    emitAction: _.debounce(
      function (actionString) {
        this.$emit(actionString);
        this.active = false;
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),
  },

  computed: {
    shouldShowMenu() {
      return (
        app.rootStore.getters.searchContextId !== app.PROVIDERS.FAVORITES.id &&
        (this.canDelete || this.canEdit)
      );
    },
  },
});
</script>
